import axios from 'axios';
import useAuthStore from '../stores/authStore';

// Use environment-specific API URL
// In production, use relative path so nginx can proxy to backend
// In development, use environment variable for local backend
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

console.log('🔧 API Configuration:', {
  baseURL: API_BASE_URL,
  fullURL: window.location.origin + API_BASE_URL,
  environment: process.env.NODE_ENV
});

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  console.log('🚀 API Request:', {
    url: config.url,
    method: config.method,
    baseURL: config.baseURL,
    fullURL: (config.baseURL || '') + (config.url || '')
  });
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('❌ API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      response: error.response?.data
    });
    return Promise.reject(error);
  }
);

export default api;